<div class="main-container">
  <div class="container">
    <div fxLayout="column" fxLayoutGap="30px" style="border:0px solid blue">
      <div fxLayout="row wrap" fxLayoutAlign="space-between" style="border:0px solid red">
        <div style="border: 0px solid black">
          <h1>{{ 'BILLING' | translate }}</h1>
          <p>{{ 'BILLING_SUBTITLE' | translate }}</p>
        </div>
        <div fxLayout="row" fxLayoutGap="10px" *ngIf="merchantType === MerchantTypeEnum.POSTPAYMENT && billingStatus !== BillingStatusEnum.UNKNOWN" style="border: 0px solid blue">
          <div>
            <p class="page-subtitle"><b>{{ 'BILLING_STATUS.TITLE' | translate }}</b>: {{ getBillingStatusLabel() }}</p>
          </div>
          <div *ngIf="merchantType === MerchantTypeEnum.POSTPAYMENT && billingStatus === BillingStatusEnum.TOPAY" style="border: 0px solid red;">
            <rezolve-primary-button (click)="onPay(amountToPay)">{{ 'PAY' | translate }}</rezolve-primary-button>
          </div>
          <div>
            <rezolve-primary-button (click)="refresh()">{{ 'REFRESH' | translate }}</rezolve-primary-button>
          </div>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutGap="0px" style="border:0px solid red;">
        <div fxFlex="33%" fxFlex.lt-md="100%" style="border:0px solid red;" *ngIf="hasAccessToPartnerDdl">
          <h2>{{ 'MERCHANT'| translate}}</h2>
          <mat-form-field appearance="standard" class="partner-ddl rezolve-form-field">
            <mat-label>{{ 'SELECT_MERCHANT' | translate }}</mat-label>
            <mat-select (selectionChange)="handleMerchantChange($event.value)" panelClass="bottom-panel-position" disableOptionCentering>
              <mat-option *ngFor="let merchant of merchantsList" [value]="merchant.id">{{merchant.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="33%" fxFlex.lt-md="100%" style="border: 0px solid red;">
          <h2 class="partner-ddl-header">{{ 'MONTH' | translate}}</h2>
          <mxp-month-picker [startDate]="dateFromObj"
                            [endDate]="dateToObj"
                            [requiredMonthRangeError]="'MONTH_RANGE_ERROR' | translate"
                            (monthRangeSelected)="handleMonthRangeSelected($event)"
                            [enableMonthNavigation]="true"
                            [labelText]="'SELECT_A_MONTH' | translate"
                            [applyButtonText]="'APPLY' | translate"></mxp-month-picker>
        </div>

        <div fxFlex="33%" fxFlex.lt-md="100%" style="border: 1px solid black; height: 300px" *ngIf="merchantType === MerchantTypeEnum.POSTPAYMENT && billingStatus === BillingStatusEnum.TOPAY">
          <div *ngIf="!qrImgUrl" fxLayoutAlign="center">
            <p>QR Code</p>
          </div>
          <div *ngIf="qrImgUrl" fxLayout="column" fxLayoutAlign="center center" style="border: 0px solid black; ">
            <img [src]="qrImgUrl" height="250" width="250" style="border:0px solid red;" />
            <h2 style="border:0px solid red"><strong>{{ qrAmount | currency: 'MXN' }}</strong></h2>
          </div>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="40%" fxFlex.lt-md="100%" fxLayout="column wrap" fxLayoutAlign="start" fxLayoutGap="55px" style="border:0px solid red">
          <div style="border:0px solid red;">
            <h2>{{ 'PAYMENT_DETAILS' | translate}}</h2>
            <table mat-table class="base-table" [dataSource]="summaryInfo" width="100%">
              <ng-container matColumnDef="item">
                <th mat-header-cell *matHeaderCellDef width="50%"> {{ 'ITEM' | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.item }}  </td>
              </ng-container>

              <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef width="50%"> {{ 'AMOUNT' | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.isCurrency ? (element.amount | currency: 'MX$ ') : element.amount }} </td>
              </ng-container>

              <tr mat-header-row class="base-table-header" *matHeaderRowDef="summarydisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: summarydisplayedColumns" class="base-table-row" [ngClass]="{'bold-row': row.displayBold}"></tr>
            </table>
          </div>
          <div style="border: 0px solid red" *ngIf="!isFirstCall">
            <h2>{{ 'BILLING_BASIS' | translate}}</h2>

            <div class="billing-base-price-row" fxLayout="row" fxLayoutAlign="space-between center">
              <span class="billing-base-label">{{ 'TARIFF_CODE' | translate }}</span>
              <span class="billing-base-value">{{ tariff?.code }}</span>
            </div>

            <div class="billing-base-price-row" fxLayout="row" fxLayoutAlign="space-between center">
              <span class="billing-base-label">{{ 'VAT' | translate }}</span>
              <span class="billing-base-value">{{ tariff?.vatPercentage}}%</span>
            </div>

            <div class="billing-base-price-row" fxLayout="row" fxLayoutAlign="space-between center">
              <span class="billing-base-label">{{ 'BASE_PAYMENTS_NUMBER' | translate }}</span>
              <span class="billing-base-value">{{ tariff?.components?.[0]?.basePaymentCount}} @ {{ tariff?.components?.[0]?.basePaymentPrice| currency : 'MX$ ' }}</span>
            </div>

            <div class="billing-base-price-row billing-table-title" fxLayout="row" fxLayoutAlign="space-between center">
              <span class="billing-base-label">{{ 'TIER_PRICING' | translate }}</span>
            </div>
            <table mat-table class="base-table" [dataSource]="tariff?.components?.[0]?.tiers || []" width="100%">

              <ng-container matColumnDef="from">
                <th mat-header-cell *matHeaderCellDef width="50%"> {{ 'NUMBER_OF_PAYMENTS' | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.from }}  {{ element.to === INT_MAX_VALUE || element.to === 0? '+' : '- ' + element.to }}  </td>
              </ng-container>

              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef width="50%"> {{ 'PRICE' | translate }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.unitPrice | currency : 'MX$ '}} </td>
              </ng-container>

              <tr mat-header-row class="base-table-header" *matHeaderRowDef="pricinRulesDisplayedColumns"></tr>
              <tr mat-row class="base-table-row" *matRowDef="let row; columns: pricinRulesDisplayedColumns"></tr>
            </table>
          </div>
        </div>
        <div *ngIf="merchantType === MerchantTypeEnum.POSTPAYMENT" fxFlex="60%" fxFlex.lt-md="100%" style="border:0px solid red">
            <h2>{{ 'PAYMENTS_TO_PROVIDER' | translate}}</h2>
            <rezolve-base-table-2 [queryArray]="query" [tableColumns]="tableColumns" [dataSource]="dataSource" [defaultParams]="defaultParams"
                                  [sortingEnabled]="true" [pageSizeOptions]="pageSizeOptions" [showInnerSpinner]="false">
            </rezolve-base-table-2>
        </div>
      </div>
    </div>
  </div>
  <div class="spinner-container" *ngIf="showSpinner"><mat-spinner></mat-spinner></div>
</div>
